module.exports = __webpack_public_path__ + "media/assets/icons/ic-close-ffaea5503ebcbd4f7be9db67ed932513.svg";